// Import necessary libraries
import {combineReducers, configureStore} from "@reduxjs/toolkit";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from 'redux-persist/lib/storage'

import { useDispatch } from "react-redux";

// Import your reducers
import authReducer from "./authSlice";

// Configure persistor with authReducer and local storage
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ["auth"],
}

const rootReducer = combineReducers({
    auth: authReducer,
});


// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
    devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools Extension
});

// Create persistor with store
const persistor = persistStore(store);

// Export store and persistor
export { store, persistor };

// Export useDispatch hook for easier dispatching
export const useAppDispatch = () => useDispatch();